import React, { ComponentType, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import * as paths from 'paths';
import * as LayoutComponents from './Components';
import * as PublicLayoutComponents from '../public/Components';

interface IMainRoute {
  layoutPaths: string[];
  component: ComponentType;
}

const useStyles = makeStyles({
  '@global html, body': {
    height: `calc(100% - 40px)`,
  },
  '@global #root': {
    height: '100%',
  },
});

export const MainWrapper: ComponentType = ({ children }) => {
  useStyles();

  return <Fragment>{children}</Fragment>;
};

export const mainRoutes: IMainRoute[] = [
  { layoutPaths: [paths.index], component: LayoutComponents.TimelineLayout },
  { layoutPaths: [paths.adminPosts], component: LayoutComponents.AllPostsLayout },
  { layoutPaths: [paths.account], component: LayoutComponents.AccountLayout },
  { layoutPaths: [paths.activity], component: LayoutComponents.ActivityLayout },
  { layoutPaths: [paths.connectionSuccess], component: LayoutComponents.ConnectionsSuccess },
  { layoutPaths: [paths.connectionFailure], component: LayoutComponents.ConnectionsFailure },
  {
    layoutPaths: [paths.content, paths.contentLike, paths.contentComment],
    component: LayoutComponents.ContentPermalinkLayout,
  },
  {
    layoutPaths: [paths.contentShare],
    component: LayoutComponents.ContentShareLayout,
  },
  { layoutPaths: [paths.groupCreate], component: LayoutComponents.NewGroupLayout },
  { layoutPaths: [paths.search], component: LayoutComponents.SearchLayout },
  { layoutPaths: [paths.groupEdit], component: LayoutComponents.EditGroupLayout },
  { layoutPaths: [paths.notifications], component: LayoutComponents.NotificationsLayout },
  {
    layoutPaths: [paths.leaderboard, paths.leaderboardView],
    component: LayoutComponents.LeaderboardLayout,
  },
  {
    layoutPaths: [paths.group, paths.groupMembers, paths.groupApproval, paths.groupRemoved],
    component: LayoutComponents.GroupLayout,
  },
  {
    layoutPaths: [
      paths.profile,
      paths.profileGroups,
      paths.profileFollowing,
      paths.profileFollowers,
    ],
    component: LayoutComponents.ProfileLayout,
  },
  {
    layoutPaths: [
      paths.groups,
      paths.groupsDepartment,
      paths.groupsLocation,
      paths.groupsOwned,
      paths.groupsFollowing,
      paths.groupsAll,
    ],
    component: LayoutComponents.GroupsIndexLayout,
  },
  {
    layoutPaths: [
      paths.people,
      paths.peopleFollowing,
      paths.peopleEveryone,
      paths.peopleDepartment,
      paths.peopleLocation,
    ],
    component: LayoutComponents.PeopleLayout,
  },
  {
    layoutPaths: [
      paths.admin,
      paths.adminAnalyticsOverview,
      paths.adminAnalyticsGroups,
      paths.adminAnalyticsUsers,
      paths.adminAnalyticsPosts,
      paths.adminAnalyticsShares,
      paths.adminAnalyticsLeaderboards,
      paths.adminPeople,
      paths.adminPeopleInvite,
      paths.adminGroups,
      paths.adminInvitations,
      paths.adminMessages,
      paths.adminLeaderboards,
      paths.adminReports,
      paths.adminContentEmails,
      paths.adminContentEmailCreate,
      paths.adminContentEmailEdit,
      paths.adminSettingsDepartments,
      paths.adminSettingsLocations,
      paths.adminSettingsDisclosures,
      paths.adminSettingsPolicies,
      paths.adminSettingsCompanyOnboarding,
      paths.adminSettingsCustomOnboarding,
      paths.adminSettingsShareTracking,
      paths.adminSettingsUserSegments,
      paths.adminSettingsSharing,
      paths.adminSettingsStickers,
    ],
    component: LayoutComponents.AdminLayout,
  },
  {
    layoutPaths: [paths.socialMediaPolicy],
    component: PublicLayoutComponents.SocialMediaPolicyLayout,
  },
  {
    layoutPaths: [paths.postCreate, paths.postEdit],
    component: LayoutComponents.PostLayout,
  },
];
